<template>
    <div class="order_contact">
        <div class="order_contact_wrapper">
            <div class="order_contact_container">
                <spinner
                    v-if="isOrder && isLoadFullInfo"
                    :key="'spinner_order_contact_container'"
                />
                <div v-if="isOrder && !isLoadFullInfo" class="order_contact__header">
                    <div class="order_contact__header_main_info">
                        <div class="order_contact__header_main_info_name">
                            {{customerName}}
                        </div>
                        <div class="order_contact__header_main_info_phone">
                            {{ customerPhone }}
                        </div>
                    </div>
                    <a :href="'tel:' + customerPhone" class="order_contact__header_logo" >
                        <img src="/icons/phone.svg">
                    </a>
                </div>

                <div v-if="isOrder && !isLoadFullInfo" class="order_contact__block">
                    <div class="order_contact__block_info">
                        <div class="order_contact__block_info_label">
                            {{ nameDelivery }}
                        </div>
                        <div class="order_contact__block_info_wrapper">
                            <div class="order_contact__block_info_wrapper_text_left">
                                {{ addressDelivery }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isOrder && !isLoadFullInfo" class="order_contact__block">
                    <div class="order_contact__block_info">
                        <div class="order_contact__block_info_label">
                            {{ __t('O.PAY') }}
                        </div>
                        <div class="order_contact__block_info_wrapper">
                            <div class="order_contact__block_info_wrapper_text_left">
                                {{ namePay }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isOrder && isDelivery" class="order_contact__block">
                    <div class="order_contact__block_info">
                        <div class="order_contact__block_info_label">
                            {{ __t('O.COURIER') }}
                        </div>
                        <div class="order_contact__block_info_wrapper">
                            <div class="order_contact__block_info_wrapper_text_left">
                                {{ nameCourier}}
                            </div>
                            <div class="order_contact__block_info_wrapper_text_right">
                                {{ phoneCourier}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import Spinner from "../../loader/Spinner.vue";
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
export default {
    name: "order_contact",
    props: {
        isLoadFullInfo: {
            type:Boolean,
            required: true,
        },
        isLoadLogs: {
            type:Boolean,
            required: true,
        },
        isOrder: {
            type:Boolean,
            required: true,
        },
    },
    emits: [],
    components: {Spinner},
    mixins: [],
    data() {
        return {}
    },
    methods: {
        getDataCourier(){
            let dataCourier = null;
            let regTemplate = 'courier';
            this.activeOrderLogs.forEach(item =>{
                let regex = new RegExp(regTemplate, 'gi');
                if (item.action_type && regex.test(item.action_type)) {
                    if(item.action_data && item.action_data.data)
                    dataCourier = item.action_data.data;
                }
            });
            regTemplate = 'couirer';
            this.activeOrderLogs.forEach(item =>{
                let regex = new RegExp(regTemplate, 'gi');
                if (item.action_type && regex.test(item.action_type)) {
                    if(item.action_data && item.action_data.data)
                        dataCourier = item.action_data.data;
                }
            });
            return dataCourier;
        },
        clickPhone(){

        }
    },
    computed: {
        ...mOrders([
            'activeOrderFullInfo',
            'activeOrderLogs'
        ]),
        customerName(){
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.customer && this.activeOrderFullInfo.customer.name){
                return this.activeOrderFullInfo.customer.name;
            }
            return ''
        },
        customerPhone(){
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.customer && this.activeOrderFullInfo.customer.phone){
                return this.activeOrderFullInfo.customer.phone;
            }
            return ''
        },
        isDelivery(){
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.is_market && !this.isLoadFullInfo && !this.isLoadLogs && this.nameCourier !==''){
                return true;
            }
            return false;
        },
        nameDelivery(){
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.is_market){
                return `${this.__t('O.DELIVERY')}`;
            } else {
                return `${this.__t('O.I_WILL_PICK_UP')}`;
            }
        },

        addressDelivery(){
            if(this.getObjectPathProperty(this.activeOrderFullInfo, 'delivery.label') && this.getObjectPathProperty(this.activeOrderFullInfo, 'is_market')
                && this.activeOrderFullInfo.is_market) {
                return this.activeOrderFullInfo.delivery.label;
            } else if(this.getObjectPathProperty(this.activeOrderFullInfo, 'is_market') && this.getObjectPathProperty(this.activeOrderFullInfo, 'pos_restaurant.address')
                && !this.activeOrderFullInfo.is_market) {
                return this.activeOrderFullInfo.pos_restaurant.address;
            }
            return '';
        },
        namePay(){
            if(this.activeOrderFullInfo && this.activeOrderFullInfo.is_pay_cache){
                return `${this.__t('O.CASH')}`;
            } else {
                return `${this.__t('O.CARD')}`;
            }
        },
        nameCourier(){
            const dataCourier = this.getDataCourier();
            if(dataCourier !== null && dataCourier.partial_name){
                return dataCourier.partial_name;
            }
            return '';
        },
        phoneCourier(){
            const dataCourier = this.getDataCourier();
            if(dataCourier !== null && dataCourier.phone){
                return dataCourier.phone;
            }
            return '';
        },
    },
}
</script>
